// How form-row shows its `help` text: "tooltip" puts an info icon beside the label that opens the text when pressed,
// "inline" writes the text under the field.
export const FIELD_HELP_MODE = "tooltip"
